import { create } from 'zustand';

interface TrialPaymentReminderState {
  /** 允许显示 trial_pay_button 的 projectId */
  allowedProjectId: string | null;
  allowedMessageId: string | null;
  /** 检查指定 projectId 和 messageId 是否都匹配 */
  isAllowed: (projectId: string, messageId?: string) => boolean;
  setAllowed: (projectId: string, messageId: string) => void;
}

export const useTrialPaymentReminderStore = create<TrialPaymentReminderState>((set, get) => ({
  allowedProjectId: null,
  allowedMessageId: null,

  setAllowed: (projectId, messageId) => set({
    allowedProjectId: projectId,
    allowedMessageId: messageId,
  }),

  isAllowed: (projectId, messageId) => {
    const { allowedProjectId, allowedMessageId } = get();
    return allowedProjectId === projectId && allowedMessageId === messageId;
  },
}));
